import React, { useReducer } from "react";
import moment from "moment";
import { predictionOptions } from "components/QueryBuilder/Elements/QueryPredictionOptions";

let QueryBuilderContext = React.createContext();

let initialState = {
  query: {},
  data: [],
  queryMetrics: [],
  granularityOptions: [],
  queryOptions: {
    listMetricsIds: [],
    currentDimensionId: [],
    startDate: moment().subtract(7, "d").format("YYYY-MM-DD"),
    endDate: moment().subtract(1, "day").format("YYYY-MM-DD"), // Exclude today,
    filters: null,
    chartType: "segments",
    granularity: "all",
    // granularityByUser represents the granularity set by the user but not related to loaded
    // or even from pasted query
    granularityByUser: undefined,
  },

  loadingData: true,
  loadingDataError: false,
  queryTextVersion: "",
  insightsFeedLoading: false,
  insightsFeed: null,
  /**
   * Represents the reference of the DOM node used to export some sort of "query report"
   * as SVG,
   */
  refReportElement: null,
  /**
   * Represents all props regarding the saved query
   */
  savedQuery: null,
  /**
   * Define whether the QB should load predictions or not
   */
  loadPredictions: false,
  /**
   * Represents all predictions related to the data which will be merged and displayed in the charts
   */
  predictions: [],
  /**
   * Determines the choosed prediction range coming from the dropdown list
   */
  predictionRange: predictionOptions[0],
  /**
   * Determines whether the uncertainty lines should be displayed or not
   */
  viewUncertainty: true,
};

// Main Query Options
// const [queryOpts, setQueryOpts] = useState({
//   listMetricsIds: pastedQuery
//     ? pastedQuery
//         .filter((d) => d.type === "metrics" && d.value)
//         .map((d) => parseInt(d.value))
//     : [],
//   currentDimensionId: null,

//   // TODO replace duplicated fields
//   startDate: startDate,
//   endDate: endDate,
//   filters: null,
//   chartType: chartType,
//   granularity: chartGranularity,
// });

// SET-QUERY - contains druid query format that runs the actual query
// SET-QUERY-STRUCTURE - contains meta data about the order, type of field etc necessary for generating the UI
// SET-QUERY-OPTIONS - UI representation of the query

let reducer = (state, action) => {
  switch (action.type) {
    case "SET-QUERY":
      return { ...state, query: action.payload, predictions: [] };
    case "SET-QUERY-STRUCTURE":
      return { ...state, queryStructure: action.payload };
    case "SET-ORIGINAL-QUERY-STRUCTURE":
      return { ...state, originalQueryStructure: action.payload };
    case "SET-QUERY-OPTIONS":
      return {
        ...state,
        queryOptions: action.payload,
        predictions: [],
        data: [],
      };
    case "SET-DATA":
      return { ...state, data: action.payload };
    case "SET-METRICS":
      return { ...state, queryMetrics: action.payload };
    case "SET-GRANULARITY-OPTIONS":
      return { ...state, granularityOptions: action.payload };
    case "SET-LOADING-DATA":
      return { ...state, loadingData: action.payload };
    case "SET-LOADING-DATA-ERROR":
      return { ...state, loadingDataError: action.payload };
    case "SET-QUERY-TEXT-VERSION":
      return { ...state, queryTextVersion: action.payload };
    case "SET-INSIGHTS-FEED-LOADING":
      return { ...state, insightsFeedLoading: action.payload };
    case "SET-INSIGHTS-FEED":
      return { ...state, insightsFeed: action.payload };
    case "SET-REF-REPORT-ELEMENT":
      return { ...state, refReportElement: action.payload };
    case "SET-LOAD-PREDICTIONS":
      return {
        ...state,
        loadPredictions: action.payload,
        // reset the default state of the chart without predictions
        ...(action.payload === false && { predictions: [] }),
      };
    case "SET-PREDICTIONS":
      return {
        ...state,
        predictions: action.payload,
      };
    case "SET-PREDICTIONS-RANGE":
      return {
        ...state,
        predictionRange: action.payload,
      };

    case "SET-VIEW-UNCERTAINTY":
      return {
        ...state,
        viewUncertainty: action.payload,
      };

    default:
      return state;
  }
};

const QueryBuilderContextProvider = (props) => {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = { state, dispatch };

  return (
    <QueryBuilderContext.Provider value={value}>
      {props.children}
    </QueryBuilderContext.Provider>
  );
};

let QueryBuilderContextConsumer = QueryBuilderContext.Consumer;

export {
  QueryBuilderContext,
  QueryBuilderContextProvider,
  QueryBuilderContextConsumer,
};
